// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1QjW7","label":"Section_label__2AdqO","contentWrap":"Section_contentWrap__ORkTx","footer":"Section_footer__1NPg5","footerInner":"Section_footerInner__1Bll2"};